import { useTranslation } from 'react-i18next';

export default function TriRootingSpiralSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-100/50">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <h2
          className="text-lg md:text-xl text-foreground-800 mb-2 text-center"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          {t('journey.triRootingSpiral.title')}
          <span className="block text-xs text-foreground-400 font-normal mt-1">
            {t('journey.triRootingSpiral.titleEn')}
          </span>
        </h2>

        {/* Spiral Visualization — CSS concentric rings */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-14 mt-8">
          {/* The spiral rings */}
          <div className="relative w-[220px] h-[220px] md:w-[260px] md:h-[260px] flex items-center justify-center">
            {/* Outer ring — AMM Alignment (dim, secondary) */}
            <div className="absolute w-full h-full rounded-full border-2 border-secondary-200 bg-secondary-50/30 flex items-center justify-center">
              <span
                className="absolute -top-2 left-1/2 -translate-x-1/2 text-[10px] text-secondary-400 bg-background-100 px-2 rounded-full whitespace-nowrap"
              >
                {t('journey.triRootingSpiral.ammAlignment')}
              </span>
            </div>

            {/* Middle ring — Awareness (dim, secondary) */}
            <div className="absolute w-[70%] h-[70%] rounded-full border-2 border-secondary-200 bg-secondary-50/30 flex items-center justify-center">
              <span
                className="absolute -top-2 left-1/2 -translate-x-1/2 text-[10px] text-secondary-400 bg-background-100 px-2 rounded-full whitespace-nowrap"
              >
                {t('journey.triRootingSpiral.awareness')}
              </span>
            </div>

            {/* Inner ring — Self Realization (lit, primary) */}
            <div className="absolute w-[38%] h-[38%] rounded-full border-2 border-primary-400 bg-primary-100/60 flex items-center justify-center shadow-[0_0_24px_rgba(var(--primary-400),0.2)]">
              <div className="flex flex-col items-center">
                <span
                  className="text-lg md:text-xl text-primary-600"
                  style={{ fontFamily: 'var(--font-heading)' }}
                >
                  i
                </span>
                <span className="text-[9px] text-primary-500 mt-0.5">
                  {t('journey.triRootingSpiral.selfRealization')}
                </span>
              </div>
            </div>
          </div>

          {/* Hint text */}
          <div className="text-center md:text-left max-w-[240px]">
            <p className="text-xs text-foreground-400 mb-2">
              {t('journey.triRootingSpiral.currentHint')}
            </p>
            <p className="text-sm font-medium text-primary-700" style={{ fontFamily: 'var(--font-heading)' }}>
              {t('journey.triRootingSpiral.selfRealization')}
            </p>
            <p className="text-xs text-foreground-500 mt-2 leading-relaxed">
              Self Realization Root 目前正在發亮——這是你的生命當下正在成熟的根源。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}